module.exports = __webpack_public_path__ + "static/media/logo.be16b322.png";